import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    refreshPage: true,
    pageRedirect: "/home",
};

const bitrixRefreshPageSlice = createSlice({
    name: 'refreshPageBitrix',
    initialState,
    reducers: {
      setRefreshPage: (state, action) => {
        state.refreshPage = action.payload;
      },
      setPageRedirect: (state, action) => {
        state.pageRedirect = action.payload;
      },
      restartData: (state) => {
        state.refreshPage = true;
        state.pageRedirect = "/home";
      },
    },
});
  
export const { setRefreshPage,setPageRedirect, restartData } = bitrixRefreshPageSlice.actions;
  
export default bitrixRefreshPageSlice.reducer;